import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import BinValueConverterBase from "./BinValueConverterBase.js";

class BinToAverageConverter extends BinValueConverterBase {
    constructor(dataPath, customResultsProcessor, silent, defaultValue) {
        super(silent, defaultValue);

        if (!(dataPath instanceof Array)) {
            throw new TypeError('dataPath must be an array containing path to the value used for classification in customData items');
        }

        this.dataPath = dataPath;

        if (typeof(customResultsProcessor) === 'undefined') {
            this.resultsProcessor = new IterableDataProcessor();
        }
        else if (!(customResultsProcessor instanceof IterableDataProcessor)) {
            throw new TypeError('customResultsProcessor must be an instance inheriting from IterableDataProcessor class');
        }
        else {
            this.resultsProcessor = customResultsProcessor;
        }
    }

	_getBinValue(bin, customData) {
		if (!(customData instanceof Array)){
            throw new TypeError('customData must be an array');
        }

        const values = []

        for (let i = 0; i < customData.length; i++) {
            values.push(this.resultsProcessor.getObjectContent(customData[i], this.dataPath));
        }

        return this._calculateAverage(values);
    }
    
    _calculateAverage(values) {
        let sum = 0;
        let count = 0;

        for (let i = 0; i < values.length; i++) {
            const value = values[i];
            if (Number.isNaN(value) || value === null) {
                continue;
            }

            sum += value;
            count ++;
        }

        if (count === 0){
            throw new Error('unable to calculate average for an empty set');
        }

        return sum / count;
    }
}

export default BinToAverageConverter;